var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodbo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3392 2C15.4377 2 15.5255 2.08277 15.5258 2.17578V9.79688C15.5255 9.89045 15.4377 9.95801 15.3392 9.95801H14.5258V14.04H15.3392C15.4379 14.04 15.5258 14.1231 15.5258 14.2168V21.8369C15.5258 21.9307 15.4379 21.999 15.3392 21.999H14.3607C14.3588 21.9991 14.3568 22 14.3549 22H8.6615C8.56307 22 8.47525 21.9323 8.47498 21.8389V14.2178C8.47517 14.1243 8.56302 14.0421 8.6615 14.042H9.47498V9.95898H8.6615C8.56292 9.95894 8.47499 9.89146 8.47498 9.79785V2.17773C8.47498 2.08461 8.56291 2.00104 8.6615 2.00098V2.00293H9.63708C9.64001 2.00278 9.6429 2.00098 9.64587 2.00098V2H15.3392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodbo1);
export default __webpack_public_path__ + "static/media/codbo1.00436d351508450a5c83094ba87c9adb.svg";
export { ForwardRef as ReactComponent };